import { Gallery } from '../types/gallery';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const GalleryApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getGalleries: build.query<any, void>({
      query: () => ({
        url: appEndpoint.gallery,
        method: 'get',
      }),
      providesTags: ['Galleries'],
    }),
    addGallery: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.gallery,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Galleries"] : []),
    }),
    updateGallery: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.gallery}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Galleries"] : []),
    }),
    deleteGallery: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.gallery}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Galleries'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetGalleriesQuery,
  useDeleteGalleryMutation,
  useUpdateGalleryMutation,
  useAddGalleryMutation,
} = GalleryApi; 